import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { ntxAPI } from '../../../../API/axiosNeatex';
import type { InvReceiveModels } from './invReceiveModels';
import type { TransactionTypesModels } from '../SharedModels';

const appendIf = (fd: FormData, key: string, val: any) => {
  if (val === undefined || val === null) return;
  if (typeof val === 'string' && val.trim() === '') return;
  fd.append(key, String(val));
};

const appendLinesIndexed = (fd: FormData, lines: any[]) => {
  for (let i = 0; i < (lines?.length ?? 0); i++) {
    const l = lines[i];
    const p = `MaterialTransactionsLineList[${i}]`;
    
    appendIf(fd, `${p}.Id`, l.id);
    appendIf(fd, `${p}.TransactionItemId`, l.transactionItemId);
    appendIf(fd, `${p}.TransactionUom`, l.transactionUom);
    appendIf(fd, `${p}.UnitPrice`, l.unitPrice ?? 0);
    appendIf(fd, `${p}.TransactionQuantityIn`, l.transactionQuantityIn ?? 0);
    appendIf(fd, `${p}.TransactionQuantityOut`, l.transactionQuantityOut ?? 0);

    appendIf(fd, `${p}.InventoryId`, l.inventoryId); // إذا عندك
    appendIf(fd, `${p}.ReferenceIdMaster`, l.referenceIdMaster);
    appendIf(fd, `${p}.ReferenceIdLine`, l.referenceIdLine);

    appendIf(fd, `${p}.TransactionTypeId`, l.transactionTypeId);
    appendIf(fd, `${p}.LotId`, l.lotId);

    // لو عندك حقول إضافية لاحقًا، أضفها هنا بنفس النمط.
  }
};

export const addReceiveTransactions = createAsyncThunk(
  'InvReceive/addReceiveTransactions',
  async (item: any, { rejectWithValue }) => {
    try {
      const fd = new FormData();

      // ✅ ملفات (تتكرر بنفس المفتاح لتمثيل array)
      const files: File[] = item.fileAttachment || [];
      for (const f of files) fd.append('FileAttachment', f, f.name); // أو fileAttachment حسب الباك

      // ✅ Scalars
      appendIf(fd, 'SupplierInvoiceNum', item.supplierInvoiceNum);
      appendIf(fd, 'Code', item.code);
      appendIf(fd, 'TransactionDate', item.transactionDate);
      appendIf(fd, 'Description', item.description);
      appendIf(fd, 'BranchId', item.branchId);
      appendIf(fd, 'TransactionAmount', item.transactionAmount ?? 0);
      appendIf(fd, 'ReferenceType', item.referenceType);
      appendIf(fd, 'ReferenceCode', item.referenceCode);
      appendIf(fd, 'ReferenceId', item.referenceId);
      appendIf(fd, 'SupplierId', item.supplierId);
      appendIf(fd, 'CustomerId', item.customerId);
      appendIf(fd, 'PersonId', item.personId);
      appendIf(fd, 'InventoryId', item.inventoryId);
      appendIf(fd, 'SubInventoryId', item.subInventoryId);
      appendIf(fd, 'Address', item.address);
      appendIf(fd, 'Note', item.note);
      appendIf(fd, 'TransactionYear', item.transactionYear ?? 0);

      const lines = item.materialTransactionsLineList || [];
      appendLinesIndexed(fd, lines);

      // fd.append('MaterialTransactionsLineList', JSON.stringify(lines));

      // debugger
      const { data } = await ntxAPI.post('InvReceive/AddReceiveTransactions', fd);
      // const { data } = await ntxAPI.post('InvReceive/AddReceiveTransactions', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// export const addReceiveTransactions = createAsyncThunk(
//   'InvReceive/addReceiveTransactions',
//   async (item: any, { rejectWithValue }) => {
//     try {
//       // console.log(JSON.stringify(item));
//       // debugger

//       const { data } = await ntxAPI.post('InvReceive/AddReceiveTransactions', item);
//       return data;
//     } catch (error: any) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

// export const updateReceiveTransactions = createAsyncThunk(
//   'InvReceive/updateReceiveTransactions',
//   async (item: any, { rejectWithValue }) => {
//     try {
//       const { data } = await ntxAPI.post('InvReceive/UpdateReceiveTransactions', item);
//       return data;
//     } catch (error: any) {
//       return rejectWithValue(error.message);
//     }
//   }
// );
export const updateReceiveTransactions = createAsyncThunk(
  'InvReceive/updateReceiveTransactions',
  async (item: any, { rejectWithValue }) => {
    try {
      const fd = new FormData();

      // ✅ ملفات (تتكرر بنفس المفتاح لتمثيل array)
      const files: File[] = item.fileAttachment || [];
      for (const f of files) fd.append('FileAttachment', f, f.name); // أو fileAttachment حسب الباك

      appendIf(fd, 'IsUpdateAttachment', item.IsUpdateAttachment ?? false); // ✅

      // ✅ Scalars
      appendIf(fd, 'Id', item.id);
      appendIf(fd, 'SupplierInvoiceNum', item.supplierInvoiceNum);
      appendIf(fd, 'Code', item.code);
      appendIf(fd, 'TransactionDate', item.transactionDate);
      appendIf(fd, 'Description', item.description);
      appendIf(fd, 'BranchId', item.branchId);
      appendIf(fd, 'TransactionAmount', item.transactionAmount ?? 0);
      appendIf(fd, 'ReferenceType', item.referenceType);
      appendIf(fd, 'ReferenceCode', item.referenceCode);
      appendIf(fd, 'ReferenceId', item.referenceId);
      appendIf(fd, 'SupplierId', item.supplierId);
      appendIf(fd, 'CustomerId', item.customerId);
      appendIf(fd, 'PersonId', item.personId);
      appendIf(fd, 'InventoryId', item.inventoryId);
      appendIf(fd, 'SubInventoryId', item.subInventoryId);
      appendIf(fd, 'Address', item.address);
      appendIf(fd, 'Note', item.note);
      appendIf(fd, 'TransactionYear', item.transactionYear ?? 0);

      const lines = item.materialTransactionsLineList || [];
      appendLinesIndexed(fd, lines);

      const { data } = await ntxAPI.post('InvReceive/UpdateReceiveTransactions', fd);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getTransactionsReceiveList = createAsyncThunk(
  'InvReceive/getTransactionsReceiveList',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get('InvReceive/GetTransactionsReceiveList');
      if (data?.succeeded) {
        //===
        return data.data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getTransactionTypesReceiveList = createAsyncThunk(
  'InvReceive/getTransactionTypesReceiveList',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get('InvReceive/GetTransactionTypesReceiveList');
      if (data?.succeeded) {
        //===
        return data.data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getReceiveTransactionsById = createAsyncThunk(
  'InvReceive/getReceiveTransactionsById',
  async (id: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get(`InvReceive/GetReceiveTransactionsById?Id=${id}`);
      if (data?.succeeded) {
        // ===
        return data.data;
      } else {
        return rejectWithValue(data?.message || 'هناك خطأ');
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState: {
  InvReceiveList: InvReceiveModels[];
  TransactionTypesReceiveList: TransactionTypesModels[];
  InvReceiveById: InvReceiveModels;
  loading: boolean;
  error: any | null;
} = {
  InvReceiveList: [],
  TransactionTypesReceiveList: [],
  InvReceiveById: {} as InvReceiveModels,
  loading: false,
  error: null
};

const InvReceiveSlice = createSlice({
  name: 'InvReceive',
  initialState,
  reducers: {
    // cleanUpTransactionsQuotationById: (state) => {
    //   state.TransactionsQuotationById = {} as InvReceiveByIdModels;
    // },
  },
  extraReducers(builder) {
    builder

      .addCase(getTransactionsReceiveList.pending, state => {
        state.loading = true;
      })
      .addCase(getTransactionsReceiveList.fulfilled, (state, action: PayloadAction<InvReceiveModels[]>) => {
        state.loading = false;
        state.InvReceiveList = action.payload;
      })
      .addCase(getTransactionsReceiveList.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getTransactionTypesReceiveList.pending, state => {
        state.loading = true;
      })
      .addCase(getTransactionTypesReceiveList.fulfilled, (state, action: PayloadAction<TransactionTypesModels[]>) => {
        state.loading = false;
        state.TransactionTypesReceiveList = action.payload;
      })
      .addCase(getTransactionTypesReceiveList.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getReceiveTransactionsById.pending, state => {
        state.loading = true;
      })
      .addCase(getReceiveTransactionsById.fulfilled, (state, action: PayloadAction<InvReceiveModels>) => {
        state.loading = false;
        state.InvReceiveById = action.payload;
      })
      .addCase(getReceiveTransactionsById.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

// export const { cleanUpTransactionsQuotationById } = InvReceiveSlice.actions;
export default InvReceiveSlice.reducer;
